<template>
    <div class="page">

        <header>
            <strong>{{dataInfo.name}}充值</strong>
            <div>请根据您的入住时间，合理充值</div>
        </header>

        <main>
            <div class="white-bg">
                <div class="info-item info-border-2">
                    <div class="info-item-name">入住公寓</div>
                    <div class="info-item-value">{{dataInfo.orgName}}</div>
                </div>
                <div class="info-item info-border-1">
                    <div class="info-item-name">房号</div>
                    <div class="info-item-value">{{dataInfo.aptName}}</div>
                </div>
                <div class="info-item info-border-2">
                    <div class="info-item-name">充值类型</div>
                    <div class="info-item-value">{{dataInfo.name}}</div>
                </div>
                <div class="info-item info-border-2">
                    <div class="info-item-name">卡内余额</div>
                    <div class="info-item-value">￥{{parseInt(dataInfo.balance/100)}}</div>
                </div>
            </div>

            <div class="white-bg">
                <div class="select-item">
                    <div :class="getSelect1" @click="select(price[0])">{{price[0]}}元</div>
                    <div :class="getSelect2" @click="select(price[1])">{{price[1]}}元</div>
                    <div :class="getSelect3" @click="select(price[2])">{{price[2]}}元</div>
                    <div :class="getSelect4" @click="select(price[3])">{{price[3]}}元</div>
                </div>

                <div class="select-commit" @click="gotoPay">
                    立即支付
                </div>

               <!-- <div class="select-toolkit">
                    <img src="../../assets/charge/img-toolkit.png" alt="">
                    <div>充值明细</div>
                </div>-->
            </div>
        </main>
    </div>
</template>

<script>
    import wx from "weixin-js-sdk";
    import {Message} from 'element-ui';

    export default {
        name: "Pay",

        data() {
            return {
                dataInfo: {},
                price: [0, 0, 0, 0],
                selectPrice: 0
            }
        },

        created() {
            document.title = "费用充值";

            let info = decodeURI(this.$route.query.data);
            info = JSON.parse(info);

            this.dataInfo.leaseID = info.leaseID;
            this.dataInfo.aptID = info.aptID;
            this.dataInfo.aptName = info.aptName;
            this.dataInfo.orgID = info.orgID;
            this.dataInfo.orgName = info.orgName;
            this.dataInfo.name = info.name;
            this.dataInfo.price = info.price;
            this.dataInfo.unit = info.unit;
            this.dataInfo.balance = info.balance;
            this.dataInfo.isPostPay = info.isPostPay;

            let price = parseInt(info.price/100);

            if (parseInt(info.price/100) === 0) {
                price = 50;
            }

            this.price[0] = price;
            this.price[1] = price * 2;
            this.price[2] = price * 3;
            this.price[3] = price * 4;
        },

        methods: {
            select(price) {
                this.selectPrice = price;
            },

            gotoPay() {
                if (this.selectPrice <= 0) {
                    Message.warning("请选择充值的金额！");
                    return;
                }
                let vue = this;

                // 微信小程序
                wx.miniProgram.getEnv(function() {

                    wx.miniProgram.navigateTo({
                        url: "/pages/bill/pay?"
                            + "leaseID=" + vue.dataInfo.leaseID
                            + "&aptID=" + vue.dataInfo.aptID
                            + "&aptName=" + encodeURI(vue.dataInfo.aptName)
                            + "&orgID=" + vue.dataInfo.orgID
                            + "&orgName=" + encodeURI(vue.dataInfo.orgName)
                            + "&name=" + encodeURI(vue.dataInfo.name)
                            + "&price=" + vue.dataInfo.price
                            + "&unit=" + encodeURI(vue.dataInfo.unit)
                            + "&balance=" + vue.dataInfo.balance
                            + "&isPostPay=" + vue.dataInfo.isPostPay
                            + "&select=" + (vue.selectPrice * 100)
                            + "&from=sundry"
                    });
                });
            }
        },

        computed: {
            getSelect1() {
                if (this.selectPrice === this.price[0]) {
                    return "select-item2";
                }
                else {
                    return "select-item1";
                }
            },

            getSelect2() {
                if (this.selectPrice === this.price[1]) {
                    return "select-item2";
                }
                else {
                    return "select-item1";
                }
            },

            getSelect3() {
                if (this.selectPrice === this.price[2]) {
                    return "select-item2";
                }
                else {
                    return "select-item1";
                }
            },

            getSelect4() {
                if (this.selectPrice === this.price[3]) {
                    return "select-item2";
                }
                else {
                    return "select-item1";
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../pay/page";

    header {
        color: white;
        background: url("../../../assets/charge/img-title.png");
        height: 140px;
        background-size: 100%;
        box-sizing: border-box;
        padding: 20px 14px;
        strong {
            font-size: 17px;
        }
        div {
            margin-top: 10px;
            font-size: 14px;
        }
    }

    main {
        margin: auto;
        width: 90%;
        position: relative;
        top: -40px;
        .white-bg {
            border-radius: 10px;
        }
        .info-border-1 {
            border-bottom: 1px $fontColor-6 dotted ;
        }
        .info-border-2 {
            border-bottom: 1px $fontColor-9 dotted ;
        }
        .info-item {
            padding: 15px 0;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            .info-item-name {
                color: $fontColor-3;
                min-width: 100px;
            }
            .info-item-value {
                color: $fontColor-9;
            }
        }
        .select-item {
            margin-top: 10px;
            display: flex;
            width: 100%;
            justify-content: space-around;
            div {
                width: 54px;
                line-height: 32px;
                text-align: center;
                border:2px solid $colorDefault;
                border-radius:15px;
            }
            .select-item1 {
                color: $colorDefault;
                background:rgba(236,247,243,1);
            }
            .select-item2 {
                color: white;
                background: $colorDefault
            }
        }
        .select-commit {
            margin-top: 30px;
            color: white;
            background: url("../../../assets/button-img.png");
            background-size: 100%;
            line-height: 57px;
            text-align: center;
            font-family:PingFang-SC-Medium,serif;
            font-weight:500;
        }
        .select-toolkit {
            font-size: 14px;
            width: 100%;
            justify-content: center;
            margin-top: 10px;
            display: flex;
            color: $fontColor-9;
            align-items: center;
            img {
                width: 15px;
            }
        }
    }
</style>
